(function () {
  if (window.__moInit) return;
  window.__moInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mo-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  function initReveals(root) {
    root.querySelectorAll('.mo-reveal, [data-mo-reveal]').forEach(function (el) {
      if (el.dataset.moInit) return; el.dataset.moInit = '1';
      if (!io || reduce) el.classList.add('mo-visible'); else io.observe(el);
    });
  }

  // Header height var
  function setHeaderH() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--mo-header-h', h.offsetHeight + 'px');
  }

  // Marquee: duplicate content to cover 2x width
  function initMarquee(root) {
    root.querySelectorAll('.mo-marquee__track').forEach(function (t) {
      if (t.dataset.moInit) return; t.dataset.moInit = '1';
      var base = t.innerHTML, guard = 0;
      while (t.scrollWidth < window.innerWidth * 2 && guard++ < 12) t.innerHTML += base;
      t.innerHTML += t.innerHTML;
    });
  }

  // Manifesto: words light up with scroll
  var manifestos = [];
  function initManifesto(root) {
    root.querySelectorAll('.mo-manifesto__text').forEach(function (el) {
      if (el.dataset.moInit) return; el.dataset.moInit = '1';
      var html = el.innerHTML.trim();
      var out = html.replace(/(<em>.*?<\/em>)|([^\s<]+)/g, function (m) { return '<span class="w">' + m + '</span>'; });
      el.innerHTML = out;
      manifestos.push(el);
    });
    onScroll();
  }
  function onScroll() {
    manifestos.forEach(function (el) {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      var p = reduce ? 1 : Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var ws = el.querySelectorAll('.w'), n = Math.round(ws.length * p);
      ws.forEach(function (w, i) { w.classList.toggle('on', i < n); });
    });
  }

  // Rail arrows
  function initRails(root) {
    root.querySelectorAll('[data-mo-rail]').forEach(function (wrap) {
      if (wrap.dataset.moInit) return; wrap.dataset.moInit = '1';
      var rail = wrap.querySelector('.mo-rail');
      wrap.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = rail.children[0]; if (!item) return;
          var step = (rail.children[1] ? rail.children[1].offsetLeft - item.offsetLeft : item.offsetWidth);
          rail.scrollBy({ left: step * (+b.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  // Product page
  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function initProduct(root) {
    root.querySelectorAll('[data-mo-product]').forEach(function (wrap) {
      if (wrap.dataset.moInit) return; wrap.dataset.moInit = '1';
      var dataEl = wrap.querySelector('[data-mo-variants]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = wrap.querySelector('[data-mo-atc]');
      var btnLabel = btn && btn.querySelector('span');
      var priceEl = wrap.querySelector('[data-mo-price]');
      var stickyPrice = document.querySelector('[data-mo-sticky-price]');
      if (dataEl && idInput) {
        var variants = JSON.parse(dataEl.textContent);
        var sets = wrap.querySelectorAll('[data-mo-opt]');
        var update = function () {
          var chosen = Array.prototype.map.call(sets, function (fs) {
            var c = fs.querySelector('input:checked'); return c ? c.value : null;
          });
          sets.forEach(function (fs) {
            var lab = fs.querySelector('[data-mo-chosen]'), c = fs.querySelector('input:checked');
            if (lab && c) lab.textContent = c.dataset.label || c.value;
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
          // availability per value of the last option given the others
          sets.forEach(function (fs, idx) {
            fs.querySelectorAll('.mo-pill').forEach(function (p) {
              var val = p.querySelector('input').value;
              var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return i === idx ? o === val : o === chosen[i]; }); });
              p.classList.toggle('is-out', !ok);
            });
          });
          if (!v) { btn.disabled = true; if (btnLabel) btnLabel.textContent = btn.dataset.unavailable; return; }
          idInput.value = v.id;
          btn.disabled = !v.available;
          if (btnLabel) btnLabel.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
          var html = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
          if (priceEl) priceEl.innerHTML = html;
          if (stickyPrice) stickyPrice.innerHTML = money(v.price);
          if (v.featured_media && v.featured_media.id) {
            var m = wrap.querySelector('[data-media-id="' + v.featured_media.id + '"]');
            var g = wrap.querySelector('.mo-gallery');
            if (m && g && m !== g.firstElementChild) g.insertBefore(m, g.firstElementChild);
          }
          var url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        };
        wrap.addEventListener('change', function (e) { if (e.target.closest('[data-mo-opt]')) update(); });
        update();
      }
      // size guide
      var dlg = wrap.querySelector('dialog.mo-dialog');
      wrap.querySelectorAll('[data-mo-open-sizes]').forEach(function (b) {
        b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); });
      });
      if (dlg) {
        dlg.querySelector('.mo-dialog__close').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }
      // sticky mobile bar
      var sticky = document.querySelector('[data-mo-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(btn);
        sticky.querySelector('button').addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
        });
      }
    });
  }

  // Quick add from product cards (delegated, bound once)
  var toastTimer;
  function toast(html) {
    var t = document.querySelector('.mo-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mo-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.mo-chip[data-variant-id]');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    chip.classList.add('is-adding');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +chip.dataset.variantId, quantity: 1 }], sections: 'cart-icon-bubble' })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        chip.classList.remove('is-adding');
        if (!res.ok) { toast(res.j.description || 'No se pudo añadir'); return; }
        chip.classList.add('is-added'); setTimeout(function () { chip.classList.remove('is-added'); }, 1600);
        var bubble = document.getElementById('cart-icon-bubble');
        var html = res.j.sections && res.j.sections['cart-icon-bubble'];
        if (bubble && html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        toast('Añadido a la bolsa · <a href="' + root + 'cart">Ver bolsa</a>');
      })
      .catch(function () { chip.classList.remove('is-adding'); toast('No se pudo añadir'); });
  });

  // Free-shipping suggestion in cart page / drawer: add, then refresh what's on screen
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mo-rec-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.classList.add('is-adding');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.moRecAdd, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        b.classList.remove('is-adding');
        if (!res.ok) { toast(res.j.description || 'No se pudo añadir'); return; }
        var drawer = b.closest('cart-drawer');
        if (!drawer) { location.reload(); return; }
        var s = res.j.sections || {};
        var pick = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d && d.innerHTML; };
        var inner = s['cart-drawer'] && pick(s['cart-drawer'], '.drawer__inner');
        if (inner) drawer.querySelector('.drawer__inner').innerHTML = inner;
        var bubble = document.getElementById('cart-icon-bubble');
        var bh = s['cart-icon-bubble'] && pick(s['cart-icon-bubble'], '.shopify-section');
        if (bubble && bh) bubble.innerHTML = bh;
      })
      .catch(function () { b.classList.remove('is-adding'); toast('No se pudo añadir'); });
  });

  function initAll(root) {
    root = root || document;
    initReveals(root); initMarquee(root); initManifesto(root); initRails(root); initProduct(root); setHeaderH();
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderH);
  if (document.readyState !== 'loading') initAll(document);
})();

// Alta en la lista de Klaviyo (pie de página). API pública de cliente: solo necesita el id público de la cuenta.
document.addEventListener('submit', function (e) {
  var f = e.target.closest('[data-mo-news]');
  if (!f) return;
  e.preventDefault();
  var email = f.email.value.trim(), msg = f.querySelector('.mo-news__msg'), btn = f.querySelector('button');
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Revisa tu email.'; return; }
  btn.disabled = true; msg.textContent = 'Enviando…';
  var attrs = { email: email };
  if (f.dataset.interes) attrs.properties = { interes: f.dataset.interes };
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VnJppa', {
    method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
    body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: f.dataset.source || 'Pie web', profile: { data: { type: 'profile', attributes: attrs } } },
      relationships: { list: { data: { type: 'list', id: 'SWNXda' } } } } })
  }).then(function (r) {
    btn.disabled = false;
    if (r.ok) {
      f.email.value = ''; msg.textContent = 'Listo. Ya estás en the motive club.';
      try { localStorage.setItem('mo-club', '1'); } catch (err) {}
    }
    else msg.textContent = 'No se pudo apuntar. Inténtalo de nuevo.';
  }).catch(function () { btn.disabled = false; msg.textContent = 'No se pudo apuntar. Inténtalo de nuevo.'; });
});

// Ventana del club: a los 8 s, una vez cada 30 días, nunca a quien ya se apuntó.
(function () {
  var pop = document.querySelector('[data-mo-pop]');
  if (!pop) return;
  var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  if (get('mo-club') || Date.now() - Number(get('mo-pop-visto') || 0) < 30 * 864e5) return;
  var last;
  var close = function () {
    pop.hidden = true; document.removeEventListener('keydown', onKey);
    if (last && last.focus) last.focus();
  };
  var onKey = function (e) { if (e.key === 'Escape') close(); };
  var cookies = function () { var c = document.getElementById('shopify-pc__banner'); return !!c && c.getClientRects().length > 0 && getComputedStyle(c).visibility !== 'hidden'; };
  var show = function () {
    if (cookies()) return setTimeout(show, 3000); // primero el aviso de cookies, luego el club
    if (get('mo-club') || document.querySelector('details[open] .menu-drawer, cart-drawer.active')) return;
    last = document.activeElement; pop.hidden = false; set('mo-pop-visto', String(Date.now()));
    document.addEventListener('keydown', onKey);
    var i = pop.querySelector('input'); if (i) i.focus({ preventScroll: true });
  };
  setTimeout(show, 8000);
  pop.addEventListener('click', function (e) { if (e.target.closest('[data-mo-pop-close]')) close(); });
})();

// Portada: los porqués van rotando bajo el titular.
(function () {
  var box = document.querySelector('[data-mo-rot]');
  if (!box || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = box.querySelectorAll('span'), i = 0;
  if (items.length < 2) return;
  setInterval(function () { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, 2400);
})();

// Historia: cada frase se enciende al entrar en pantalla.
(function () {
  var lines = document.querySelectorAll('.mo-historia [data-mo-line]');
  if (!lines.length) return;
  if (!('IntersectionObserver' in window)) { lines.forEach(function (l) { l.classList.add('on'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -18% 0px' });
  lines.forEach(function (l) { io.observe(l); });
})();

// Conjuntos: añade todas las prendas del look (con la talla elegida) a la bolsa de una vez.
document.addEventListener('submit', function (e) {
  var f = e.target.closest('[data-mo-set]');
  if (!f) return;
  e.preventDefault();
  var sel = f.querySelectorAll('select'), items = [], msg = f.querySelector('.mo-set__msg'), btn = f.querySelector('button');
  for (var i = 0; i < sel.length; i++) {
    if (!sel[i].value) { var lb = sel[i].closest('.mo-set__info').querySelector('.mo-set__title'); msg.textContent = 'Elige la talla de ' + (lb ? lb.textContent.trim() : 'cada prenda') + ' para añadir el conjunto.'; sel[i].focus(); return; }
    items.push({ id: Number(sel[i].value), quantity: 1 });
  }
  btn.disabled = true; msg.textContent = 'Añadiendo…';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function (r) { if (!r.ok) throw r; msg.textContent = 'Conjunto añadido. Abriendo tu bolsa…'; window.location.href = '/cart'; })
    .catch(function () { btn.disabled = false; msg.textContent = 'No se pudo añadir. Inténtalo de nuevo.'; });
});

// Fecha estimada de entrega (días laborables: fabricación + transporte).
(function () {
  var el = document.querySelector('[data-mo-eta]');
  if (!el) return;
  var add = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
  var f = function (d) { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace('.', '').replace(',', ''); };
  el.innerHTML = '<b>Pídelo hoy y te llega entre el ' + f(add(+el.dataset.min)) + ' y el ' + f(add(+el.dataset.max)) + '.</b>';
})();
